import gql from 'graphql-tag';

import type { Utilities } from '@change-corgi/core/react/utilityContext';

import type { GammaSharedPetitionLocaleQuery, GammaSharedPetitionLocaleQueryVariables } from './petitionLocale.graphql';

export async function getPetitionLocale(
	slugOrId: string,
	utilities: Pick<Utilities, 'gql' | 'http'>,
): Promise<string | undefined> {
	const { data } = await utilities.gql.fetch<GammaSharedPetitionLocaleQuery, GammaSharedPetitionLocaleQueryVariables>({
		query: gql`
			query GammaSharedPetitionLocale($slugOrId: String!) {
				petition: petitionBySlugOrId(slugOrId: $slugOrId) {
					id
					originalLocale {
						localeCode
					}
				}
			}
		`,
		variables: { slugOrId },
		rejectOnError: false,
	});

	return data?.petition?.originalLocale?.localeCode;
}
